<template>
  <div-loading v-if="routeLoading" />
  <router-view v-else v-slot="{ Component, route }">
    <transition name="fade" mode="out-in">
      <component :is="Component" :key="route.path" />
    </transition>
  </router-view>
  <global-footer />
  <DialogWrapper :transition-attrs="{ name: 'dialog' }" />
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { onMounted, watchEffect } from 'vue'
import { useI18n } from 'vue-i18n'
import { useThemeStore } from './store/theme'
import { DialogWrapper } from 'vue3-promise-dialog'
import { useLoadingStore } from './store/loading'
const { locale } = useI18n({ useScope: 'global' })
const { theme } = storeToRefs(useThemeStore())
const { routeLoading } = storeToRefs(useLoadingStore())

watchEffect(() => {
  document.body.className = `${locale.value} ${theme.value}`
})

onMounted(async () => {
  window.version = `Current Version => ${VITE_APP_VERSION}`
})
</script>

<style lang="less">
@import '@/assets/less/global.less';
</style>
<style scoped>
div {
  margin-bottom: 80px; /* to avoid a conflict with footer */
}
</style>
